import { BASE_REST_API_URL } from 'common/constants';
import type { BaseAPIParams } from 'lib/utils/BaseAPIParams';
import type { StrapiApiResponse } from 'api/types/strapiApiResponse';
import { buildQuery } from '@enmon/commons/lib/tools/utils/buildQuery';
import type { SerializedThirdParty } from '@enmon/commons/lib/tools';
import { BaseApiClient } from './baseApiClient';

export type ThirdPartiesFilter = BaseAPIParams<SerializedThirdParty>;

export type FindThirdPartiesResult = StrapiApiResponse<SerializedThirdParty>;

export class ThirdPartiesApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('third-parties', BASE_REST_API_URL, jwt);
  }

  public async find(filter: ThirdPartiesFilter, signal: AbortSignal | undefined): Promise<FindThirdPartiesResult> {
    const { fields, page, pageSize, populate } = filter;

    const response = await this.axios.get<FindThirdPartiesResult>('', {
      params: buildQuery<SerializedThirdParty>({
        filters: {},
        pagination: {
          page,
          pageSize,
        },
        fields,
        populate,
      }),
      signal,
    });

    return response.data;
  }
}
